module.exports = __webpack_public_path__ + "img/account.6dc2c993.svg";